import styled from 'styled-components';
export var HeaderButton = styled.button.withConfig({
  displayName: "elements__HeaderButton",
  componentId: "sc-1h9b4yf-0"
})(["display:flex;align-items:center;height:100%;width:100%;position:relative;padding:0 2.4rem 0 1.6rem;cursor:pointer;text-align:left;font-size:", ";border:1px solid ", ";border-radius:", ";background:linear-gradient( 180deg,", " 0%,", " 100% );color:", ";&::after{content:'';position:absolute;right:1.4rem;top:37%;width:0;height:0;border:0 solid transparent;border-right-width:3px;border-left-width:3px;border-bottom:3px solid ", ";}&::before{content:'';position:absolute;right:1.4rem;bottom:33%;width:0;height:0;border:0 solid transparent;border-left-width:3px;border-right-width:3px;border-top:3px solid ", ";}&:disabled{cursor:not-allowed;opacity:0.4;}"], function (_ref) {
  var fonts = _ref.theme.fonts;
  return fonts.size.medium;
}, function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.lightGrey;
}, function (_ref3) {
  var dimensions = _ref3.theme.dimensions;
  return dimensions.radius;
}, function (_ref4) {
  var palette = _ref4.theme.palette;
  return palette.white;
}, function (_ref5) {
  var palette = _ref5.theme.palette;
  return palette.paleGrey;
}, function (_ref6) {
  var palette = _ref6.theme.palette;
  return palette.spaceGrey;
}, function (_ref7) {
  var palette = _ref7.theme.palette;
  return palette.spaceGrey;
}, function (_ref8) {
  var palette = _ref8.theme.palette;
  return palette.spaceGrey;
});
export var HeaderContent = styled.div.withConfig({
  displayName: "elements__HeaderContent",
  componentId: "sc-1h9b4yf-1"
})(["vertical-align:middle;display:inline-block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:100%;"]);
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "sc-1h9b4yf-2"
})(["position:relative;user-select:none;height:3.8rem;"]);